module.exports = __webpack_public_path__ + "img/dream-journal_B095GD5P26.9c5bbc29.jpg";